"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
const createTypography = (size, lineHeight, weight = 400, letterSpacing = 0) => `font-weight: ${weight};
   font-size: ${size}px;
   line-height: ${lineHeight}px;
  ${letterSpacing ? `letter-spacing: ${letterSpacing}px;` : ''}
`.trim();
const createBaseTypography = createTypography.bind('');
const createHeaderTypography = createTypography.bind('');
const adaptive = (desktop, mobile) => `
${desktop}
${`@media (max-width: 720px) {${mobile || desktop}}`}
`.trim();
const types = {
    bold64: createBaseTypography(64, 72, 700),
    medium64: createBaseTypography(64, 72, 500),
    regular64: createBaseTypography(64, 72, 400),
    bold52: createBaseTypography(52, 64, 700),
    medium52: createBaseTypography(52, 64, 500),
    regular52: createBaseTypography(52, 64, 400),
    bold40: createBaseTypography(40, 48, 700),
    medium40: createBaseTypography(40, 48, 500),
    regular40: createBaseTypography(40, 48, 400),
    bold32: createBaseTypography(32, 40, 700),
    medium32: createBaseTypography(32, 40, 500),
    regular32: createBaseTypography(32, 40, 400),
    bold28: createBaseTypography(28, 36, 700),
    medium28: createBaseTypography(28, 36, 500),
    regular28: createBaseTypography(28, 36, 400),
    bold24: createBaseTypography(24, 32, 700),
    medium24: createBaseTypography(24, 32, 500),
    regular24: createBaseTypography(24, 32, 400),
    bold22: createBaseTypography(22, 28, 700),
    medium22: createBaseTypography(22, 28, 500),
    regular22: createBaseTypography(22, 28, 400),
    bold20: createBaseTypography(20, 28, 700),
    medium20: createBaseTypography(20, 28, 500),
    regular20: createBaseTypography(20, 28, 400),
    bold18: createBaseTypography(18, 24, 700),
    medium18: createBaseTypography(18, 24, 500),
    regular18: createBaseTypography(18, 24, 400),
    bold16: createBaseTypography(16, 22, 700),
    medium16: createBaseTypography(16, 22, 500),
    regular16: createBaseTypography(16, 22, 400),
    bold14: createBaseTypography(14, 16, 700),
    medium14: createBaseTypography(14, 16, 500),
    regular14: createBaseTypography(14, 16, 400),
    bold12: createBaseTypography(12, 20, 700),
    medium12: createBaseTypography(12, 20, 500),
    regular12: createBaseTypography(12, 20, 400),
    bold10: createBaseTypography(10, 20, 700),
    medium10: createBaseTypography(10, 20, 500),
    regular10: createBaseTypography(10, 20, 400),
    buttonM: createBaseTypography(14, 20, 500),
    buttonS: createBaseTypography(14, 20, 500),
    buttonL: createBaseTypography(14, 20, 500),
    input: createBaseTypography(14, 24, 'normal'),
    tableTitle: createBaseTypography(16, 24, 'bold'),
    tableText: createBaseTypography(16, 24, 'normal'),
};
exports.typography = Object.assign(Object.assign({}, types), { head: {
        bold: adaptive(createHeaderTypography(64, 72, 700), createHeaderTypography(32, 56, 700)),
        medium: adaptive(createHeaderTypography(64, 72, 500), createHeaderTypography(32, 56, 500)),
        regular: adaptive(createHeaderTypography(64, 72, 400), createHeaderTypography(32, 56, 400)),
    }, pulsHead2: {
        regular: adaptive(createHeaderTypography(24, 32, 400), createHeaderTypography(20, 24, 400)),
    }, authHead: {
        regular: adaptive(createHeaderTypography(32, 40, 400), createHeaderTypography(24, 32, 400)),
    }, subhead1: {
        bold: adaptive(types.bold32, types.bold32),
        medium: adaptive(types.medium32, types.medium32),
        regular: adaptive(types.regular32, types.regular32),
    }, subhead2: {
        bold: adaptive(types.bold18, types.bold16),
        medium: adaptive(types.medium18, types.medium16),
        regular: adaptive(types.regular18, types.regular16),
    }, pulsSubhead3: {
        bold: adaptive(types.bold22, types.bold18),
        medium: adaptive(types.medium22, types.medium18),
        regular: adaptive(types.regular22, types.regular18),
    }, pulsSubhead4: {
        bold: adaptive(types.bold16, types.bold14),
        medium: adaptive(types.medium16, types.medium14),
        regular: adaptive(types.regular16, types.regular14),
    }, body1: {
        bold: adaptive(types.bold20, types.bold18),
        medium: adaptive(types.medium20, types.medium18),
        regular: adaptive(types.regular20, types.regular18),
    }, body2: {
        bold: adaptive(types.bold16),
        medium: adaptive(types.medium16),
        regular: adaptive(types.regular16),
    }, caption1: {
        bold: adaptive(types.bold14),
        medium: adaptive(types.medium14),
        regular: adaptive(types.regular14),
    }, caption2: {
        bold: adaptive(types.bold12),
        medium: adaptive(types.medium12),
        regular: adaptive(types.regular12),
    }, caption3: {
        bold: adaptive(types.bold10),
        medium: adaptive(types.medium10),
        regular: adaptive(types.regular10),
    }, itemValue: {
        bold: adaptive(types.bold22, types.bold16),
        medium: adaptive(types.medium22, types.medium16),
        regular: adaptive(types.regular22, types.regular16),
    }, buttons: {
        M: adaptive(createBaseTypography(14, 20, 500)),
        L: adaptive(createBaseTypography(16, 24, 500)),
    }, inputs: {
        text: adaptive(createBaseTypography(14, 24, 400)),
    } });
